/**
 * Catálogo de planes Hispano Medical Plan 2027 (mockup Programa Agentes).
 * Precios y beneficios alineados al PDF / sitio estático enviado.
 * famPrice: tramos Familiar por número de personas.
 */

export const famPrice = (n) => {
  const map = { 2: 95, 3: 125, 4: 149, 5: 175 }
  if (map[n]) return map[n]
  return 175 + 29 * (n - 5)
}

/** Precios de referencia del mercado (mockup oct 2026) para calculadora / ahorro */
export const MARKET_BY_SIZE = { 1: 69, 2: 90, 4: 159, 5: 189 }

export const HMP_PLANS_2027 = [
  {
    id: 'tusalud',
    name: 'Tu Salud',
    price: 55,
    was: 79,
    apiMatch: ['tu salud', 'individual'],
    apiExclude: ['plus', 'senior', 'familiar', 'empresa'],
    mkt: 'Otro plan del mercado: $69 y solo 50% en consultas.',
    for: 'Adultos que quieren un médico de cabecera sin pagar por cada visita.',
    benefits: [
      ['Consultas ilimitadas $0', 'Presenciales y por video, en las 11 sedes.'],
      ['Wellness Visit anual', 'Sangre (~32 parámetros), HbA1c, orina y EKG, 100% cubiertos.'],
      ['20% en no cubiertos', 'Laboratorios, estudios, inyecciones y procedimientos.'],
      ['Salud mental $30', 'Sesión con especialista a precio preferencial.'],
      ['Medicamentos', 'Precio preferencial en genéricos.'],
      ['WhatsApp directo', 'Citas, resultados y dudas, siempre en español.']
    ]
  },
  {
    id: 'senior',
    name: 'Tu Salud Senior',
    price: 64,
    was: 89,
    apiMatch: ['senior'],
    mkt: 'Otro plan del mercado: $65 con 1 Wellness al año.',
    for: 'Adultos de 60 años o más, sin seguro ni requisitos migratorios.',
    benefits: [
      ['Consultas ilimitadas $0', 'Presenciales y por video, sin costo por visita.'],
      ['2 Wellness Visits al año', 'Sangre, HbA1c, orina y EKG, 100% cubiertos.'],
      ['30% en no cubiertos', 'Laboratorios, estudios, inyecciones y procedimientos.'],
      ['PAP y PSA incluidos', 'Prevención de cáncer de cuello uterino y próstata.'],
      ['Monitor de presión de regalo', 'Al completar el tercer mes de membresía.'],
      ['Salud mental $30', 'Y precio preferencial en medicamentos.']
    ]
  },
  {
    id: 'plus',
    name: 'Tu Salud Plus',
    price: 89,
    was: 129,
    badge: 'Más popular',
    apiMatch: ['plus'],
    mkt: 'Otro plan del mercado: $99.',
    for: 'Diabetes, presión alta, tiroides, o quien quiere la prevención más completa.',
    benefits: [
      ['Consultas ilimitadas $0', 'Presenciales y por video, en las 11 sedes.'],
      ['2 Wellness Visits al año', 'Con ultrasonido de mama o abdominal completo.'],
      ['Imágenes con 30% de descuento', 'Ultrasonidos y rayos X.'],
      ['Control de crónicos', 'HbA1c cada 3 meses y plan de seguimiento.'],
      ['PAP, PSA y 30% de descuento', 'En todo lo que no está cubierto.'],
      ['Glucómetro o monitor de regalo', 'Al completar el tercer mes de membresía.']
    ]
  },
  {
    id: 'familiar',
    name: 'Familiar',
    fam: true,
    apiMatch: ['familiar', 'familia'],
    for: 'Toda la familia en un solo pago. Cualquier combinación de adultos y niños desde 2 años.',
    benefits: [
      ['Cada adulto', 'Consultas ilimitadas $0, Wellness anual, PAP y PSA, 30% en no cubiertos, salud mental $30.'],
      ['Cada niño', 'Consultas ilimitadas $0, presenciales y por video.'],
      ['Chequeo escolar o deportivo', 'Anual, con formulario firmado.'],
      ['Notas médicas', 'Para la escuela, cuando las necesiten.'],
      ['Vacunas escolares', 'A precio de miembro.'],
      ['30% en no cubiertos', 'Laboratorios y estudios.']
    ],
    marketBySize: { 2: 90, 4: 159, 5: 189 }
  },
  {
    id: 'empresas',
    name: 'Empresas',
    price: 49,
    unit: 'por empleado al mes · mínimo 5',
    marketPrice: 60,
    apiMatch: ['empresa', 'empresarial', 'corporate'],
    mkt: 'Otro plan del mercado: $60 por empleado.',
    for: 'Negocios hispanos que quieren dar beneficios médicos sin pagar un seguro de grupo.',
    benefits: [
      ['Consultas ilimitadas $0', 'Para cada empleado inscrito, en las 11 sedes.'],
      ['2 Wellness Visits al año', 'Sangre, HbA1c, orina y EKG, 100% cubiertos.'],
      ['PAP y PSA incluidos', 'Prevención para todo el equipo.'],
      ['Notas de trabajo', 'Incapacidad y regreso al trabajo el mismo día.'],
      ['Exámenes pre-empleo', 'Con 30% de descuento para nuevos empleados.'],
      ['Un solo cobro mensual', 'Altas y bajas de empleados sin papeleo.']
    ]
  }
]

/**
 * Asocia un plan de catálogo con un plan del API por nombre.
 * @param {Object} catalogPlan
 * @param {Array} apiPlans
 * @returns {Object|null}
 */
export function matchApiPlan(catalogPlan, apiPlans) {
  if (!Array.isArray(apiPlans) || !apiPlans.length) return null
  const exclude = (catalogPlan.apiExclude || []).map((s) => s.toLowerCase())
  const matchers = (catalogPlan.apiMatch || []).map((s) => s.toLowerCase())
  return (
    apiPlans.find((p) => {
      const name = String(p.name || '').toLowerCase()
      if (exclude.some((ex) => name.includes(ex))) return false
      return matchers.some((m) => name.includes(m))
    }) || null
  )
}

/**
 * Busca la ficha de marketing (mockup 2027) para un plan del API.
 * @param {Object} apiPlan
 * @returns {Object|null}
 */
export function findCatalogForApiPlan(apiPlan) {
  if (!apiPlan) return null
  return HMP_PLANS_2027.find((catalog) => matchApiPlan(catalog, [apiPlan])) || null
}

/**
 * Planes aún no disponibles para pago en línea (contrato fase actual).
 * @param {string} catalogId
 * @returns {boolean}
 */
export function isOnlinePurchaseDisabled() {
  return false
}

/**
 * Enriquece un plan del API con beneficios y textos del catálogo 2027.
 * @param {Object} apiPlan
 * @returns {Object}
 */
export function enrichApiPlan(apiPlan) {
  const catalog = findCatalogForApiPlan(apiPlan)
  if (!catalog) return { ...apiPlan }
  return {
    ...apiPlan,
    name: catalog.name || apiPlan.name,
    price: catalog.fam ? apiPlan.price : (catalog.price != null ? catalog.price : apiPlan.price),
    marketingBenefits: catalog.benefits || [],
    catalogId: catalog.id,
    catalogFor: catalog.for || null,
    catalogBadge: catalog.badge || null,
    catalogWas: catalog.was || null,
    catalogUnit: catalog.unit || null,
    purchaseDisabled: isOnlinePurchaseDisabled(catalog.id)
  }
}

/**
 * Filtra y ordena los planes HMP 2027 del API según el catálogo del mockup.
 * @param {Array} apiPlans
 * @returns {Array}
 */
export function enrichAndOrderHmpPlans(apiPlans) {
  if (!Array.isArray(apiPlans) || !apiPlans.length) return []
  return HMP_PLANS_2027.map((catalog) => {
    const api = matchApiPlan(catalog, apiPlans)
    return api ? enrichApiPlan(api) : null
  }).filter(Boolean)
}
